import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getCoachAiName } from 'utils/i18n';
import createLocation from 'utils/createLocation';
import Box from 'components/Box';
import Button from 'components/Button';
import CoachAiAvatar from 'components/Avatar/CoachAIAvatar';
import { COACH_AI_ROUTE } from 'utils/routes';
import { SearchWidgetCard } from './SearchWidgetCard';
import useSearchParameter from 'hooks/useSearchParameter';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CoachAiLauncherWidget() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useSearchParameter = useSearchParameter('q'),
    _useSearchParameter2 = _slicedToArray(_useSearchParameter, 1),
    q = _useSearchParameter2[0];
  var coachAiName = getCoachAiName();
  return /*#__PURE__*/_jsxs(SearchWidgetCard, {
    icon: /*#__PURE__*/_jsx(CoachAiAvatar, {}),
    title: coachAiName,
    children: [/*#__PURE__*/_jsx(Box, {
      as: "p",
      style: {
        whiteSpace: 'pre-wrap'
      },
      my: "xs",
      children: t('coach_ai_ask_about', {
        coachAiName: coachAiName,
        searchInput: q
      })
    }), /*#__PURE__*/_jsx(Button, {
      fullWidth: true,
      iconRight: "arrow-right",
      variant: "primary",
      as: Link,
      to: createLocation(COACH_AI_ROUTE, {
        q: q
      }),
      children: t('coach_ai_ask', {
        coachAiName: coachAiName
      })
    })]
  });
}